const access = (function () {
    var navigation: any = null;
    let isOnline: boolean = true;
    
    var setNavigationAccess = function(val: any) {
        navigation = val
    }
    var getNavigationAccess = function() {
        return navigation;
    }
    const setInternetStatus = function(val: boolean) {
        isOnline = val
    }
    const getInternetStatus = function() {
        return isOnline;
    }

    return {
        setNavigationAccess,
        getNavigationAccess,
        setInternetStatus,
        getInternetStatus
    }
})()

export default access